import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PassengerCodeOfConductModal from './PassengerCodeOfConductModal';

export default function PassengerConductAcknowledgment({ checked, onChange }) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setModalOpen(true);
  };

  return (
    <>
      <div className="cost-sharing-disclaimer">
        <div className="cost-sharing-declaration-row passenger-conduct-row">
          <input
            type="checkbox"
            id="passenger-code-accepted"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span className="declaration-text">
            {t('costSharing.passengerConductBefore')}{' '}
            <button type="button" className="conduct-inline-link" onClick={openModal}>
              {t('costSharing.passengerConductLink')}
            </button>
            {t('costSharing.passengerConductAfter')}
          </span>
        </div>
      </div>
      {modalOpen && <PassengerCodeOfConductModal onClose={() => setModalOpen(false)} />}
    </>
  );
}
